import React from 'react'
import ReactModal from 'react-modal'
import { Link } from 'react-router-dom'
import { FileX } from 'lucide-react'

function CaseDeletedModal({uploadNew, onClose, doNotClose = true}) {
  return (
    <ReactModal
    shouldCloseOnEsc = {doNotClose}
    shouldCloseOnOverlayClick = {doNotClose}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 55,
          backgroundColor: 'rgba(20,33,61,.45)'
        },
        content: {
            zIndex: 55,
            height: 'auto',
            width: 'calc(100vw - 32px)',
            maxWidth: '400px',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: '28px 24px 24px',
            border: '1px solid rgba(20,33,61,.12)',
            borderRadius: '8px',
            backgroundColor: '#fffdf8',
            boxShadow: '0 16px 40px rgba(20,33,61,.3)',
        }
      }}
    >
        <div className='flex items-center flex-col text-center font-plexsans'>
            <div
              className='flex items-center justify-center rounded-full mb-4 w-12 h-12 bg-brass/[.1] text-brass'>
              <FileX size={22} strokeWidth={1.8}/>
            </div>
            <div className='font-spectral font-medium text-[19px] leading-[1.3] text-navy mb-2'>
              This case is no longer available
            </div>
            <div className='font-plexsans font-normal text-[13.5px] leading-[1.6] text-navy/[.6]'>
              It may have been removed by you or by the admin. Closed cases are deleted automatically after 7 days.
            </div>
            <Link to="/client/cases" className='block w-full mt-6'>
              <div
                className="w-full flex justify-center items-center cursor-pointer rounded-md hover:opacity-90 h-11 font-plexsans font-semibold text-[14px] leading-none text-ivory bg-brass"
              >Back to my cases</div>
            </Link>
         </div>
    </ReactModal>
  )
}

export default CaseDeletedModal
